import apiClient from '../apiClient';
import { DELETE_IMAGE_ACCOMODATION_PROFILE_URL } from '../apiUrl';

const deleteImageAccomodationProfileApi = Id => {
  return apiClient.delete(DELETE_IMAGE_ACCOMODATION_PROFILE_URL(Id));
};

export default deleteImageAccomodationProfileApi;
